<template>
  <vf-input
    v-bind="$props"
    v-model="modelValue"
    data-test-id="input-calendar"
    required
    type="date"
    @change="$emit('change', $event)"
  >
    <slot />
  </vf-input>
</template>

<script lang="ts" setup>
defineProps<{
  placeholder?: string
  disabled?: boolean
  invalid?: boolean
  variant?: 'inverse'
  min?: string
  max?: string
}>()

defineEmits<{ change: [value: string] }>()

const modelValue = defineModel<string>({ required: true })
</script>
